import { DateString } from './date-string';

export enum ApiStatusResponse {
  success = 'success',
  fail = 'fail',
  error = 'error',
}

export type StringDictionary = Record<string, string>;

export type Field = {
  value: string | boolean;
  isValid: boolean | undefined;
};

export type BooleanField = {
  value: boolean;
  isValid: boolean | undefined;
};

export enum ProgramType {
  flex = 'flex',
  breath = 'breathe',
}

export type Program = ProgramType;

export enum Range {
  ONE_1_20 = 'one_1_20',
  TWO_21_40 = 'two_21_40',
  THREE_41_60 = 'three_41_60',
  FOUR_61_80 = 'four_61_80',
  FIVE_81_100 = 'five_81_100',
}

export interface ExistingAnswer {
  id: string;
  score: number;
}

enum AssessmentAnswerLabel {
  Never = 'Never',
  Rarely = 'Rarely',
  Sometimes = 'Sometimes',
  Frequently = 'Frequently',
  Always = 'Always',
}

export interface AssessmentAnswer {
  id: string;
  score: number;
  answerText: AssessmentAnswerLabel;
  selected: boolean;
}

export interface AssessmentQuestion {
  id: string;
  questionText: string;
  answerOptions: AssessmentAnswer[];
}

export enum AssessmentCategory {
  stressManagement = 'stressManagement',
  anxietyManagement = 'anxietyManagement',
  burnoutManagement = 'burnoutManagement',
  resilienceSkills = 'resilienceSkills',
}

export interface AssessmentApiResponse {
  status: ApiStatusResponse;
  data: {
    assessmentId: string;
    accessCode: string;
    templateId: string;
    templateVersion: string;
    subCategoryMaxScores: Record<AssessmentCategory, number>;
    questions: AssessmentQuestion[];
    completionTimestamp?: DateString;
    existingAnswers: Record<string, ExistingAnswer>;
  };
}

export interface AssessmentResultApiResponse {
  status: ApiStatusResponse;
  data: {
    assessmentResult: {
      flexScore: number;
      scoreDetails: {
        subCategoryScores: Record<AssessmentCategory, number>;
      };
      completionTimestamp: DateString;
    };
    flexCategory: string;
    subCategoryMaxScores: Record<AssessmentCategory, number>;
  };
}
